import { render } from "./Navbar.vue?vue&type=template&id=08e1b2ea&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=08e1b2ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e1b2ea"]])

export default __exports__